import components from './components'
import * as constants from './constants'

export default { components, constants }



// WEBPACK FOOTER //
// ./src/personnel/index.js